import React, { useState, useEffect } from "react";
import { modifySelectedCred } from "../../../redux/actions/credActions";
import { useSelector, useDispatch } from "react-redux";
import AtlassianFormBuilder from "../../../formBuilder/AtlassianFormBuilder";
import { clone } from "../../../common/utils/helper";

const TokenPage = () => {
  const dispatch = useDispatch();
  const selectedCred = useSelector((state) => state.auth.selectedCred);
  const [values, setValues] = useState([]);

  const callback = (extConfigValues) => {
    let credentials = clone(selectedCred);
    credentials.name = extConfigValues.find((v) => v.id === "NAME").value;
    if (!credentials.data) {
      credentials.data = {
        token: "",
      };
    }
    credentials.data.token = extConfigValues.find((v) => v.id === "TOKEN").value;

    dispatch(modifySelectedCred(credentials));
  };

  useEffect(() => {
    setValues([
      {
        id: "NAME",
        value: selectedCred.name,
      },
      {
        id: "TOKEN",
        value: selectedCred.data ? selectedCred.data.token : "",
      },
    ]);
  }, [selectedCred]);

  const fields = [
    {
      id: "NAME",
      title: "Credential name",
      type: "TEXT",
    },
    {
      id: "TOKEN",
      title: "Token",
      type: "TEXT",
    },
  ];

  return (
    <>
      <AtlassianFormBuilder fields={fields} values={values} options={[]} update={callback} />
    </>
  );
};
export default TokenPage;
